// import EmptyCase from "./EmptyCase";
import HistoryContribution from "@components/contributeCase/caseUpdates/HistoryContribution";
export default function CaseUpdates({ setTab }) {
  return <HistoryContribution setTab={setTab} />;
}
